<template>
  <div v-if="message" class="message-sucess">
    {{ message }}
  </div>
</template>

<style>
.message-sucess {
  background-color: #d1e7dd !important;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 10px;
  color: #0a3622;
  font-weight: 500;
}

.text-msg {
  font-size: 12px;
}
</style>

<script>
export default {
  name: "SuccessMessage",
  props: {
    message: String,
  },
};
</script>
